<ng-container *ngIf="selectedRole === role">
  <svg class="check" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.3333 4L5.99996 11.3333L2.66663 8" stroke="#EE7802" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</ng-container>
